import { esusApi } from "@/services/api";

export type ResumeIndicatorC6Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorC6Data {
	totalElderlyCitizens: number = 0;
	totalElderlyCitizensInPeriod: number = 0;
	totalElderlyCitizensInPeriodScore: number = 0;
	maxElderlyCitizensInPeriodScore: number = 0;
}

export async function getResumeIndicatorC6({ uf, ibgeCode, ...params }: ResumeIndicatorC6Params) {
	const response = await esusApi.get<ResumeIndicatorC6Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c6/resume`,
		params
	);
	return response.data ?? new ResumeIndicatorC6Data();
}
